export default __webpack_public_path__ + "static/media/warning--light-rail-transit-vehicles--g1.18a56f76.png";